import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { isLoggedIn } = useSelector((state: RootState) => state.auth);

  if (isLoggedIn === false) {
    return <Navigate to="/flowtone/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
